/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/middleware/auth'

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: '/',
	scrollBehavior() {
		return {x: 0, y: 0}
	},
	routes: [
		{
			path: '/',
			redirect: '/dashboard'
		},
		{
			path: '/',
			component: () => import('@/layouts/full-page/FullPage.vue'),
			children: [
				{
					path: '/login',
					name: 'page-login',
					component: () => import('@/views/pages/Login.vue')
				},
				{
					path: '/reset',
					name: 'resetPassword',
					component: () => import('@/views/pages/ResetPassword.vue')
				},
				{
					path: '/register',
					name: 'register',
					component: () => import('@/views/pages/Register.vue')
				},
				{
					path: '/forgetpassword',
					name: 'forgetpassword',
					component: () => import('@/views/pages/ForgetPassword.vue')
				},
				{
					path: '/niet-gevonden',
					name: 'niet-gevonden',
					component: () => import('@/views/pages/Error404.vue')
				},
			]
		},
		{
			path: '/dashboard',
			component: () => import('@/layouts/main/Main.vue'),
			children: [
				{
					path: '/',
					name: 'dashboard',
					component: () => import('@/views/dashboard.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/orders',
					name: 'orders',
					component: () => import('@/views/orders/orders.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/orders/voltooid',
					name: 'order history',
					component: () => import('@/views/orderhistory/overview.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/orders/dropship',
					name: 'order dropshop',
					component: () => import('@/views/orderdropship/overview.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/products',
					name: 'products',
					component: () => import('@/views/products/productsPage.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/products/pools',
					name: 'productsPools',
					component: () => import('@/views/products/pools.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/products/pools/edit/:id',
					name: 'productsPoolsEdit',
					component: () => import('@/views/products/pools/edit.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/packages',
					name: 'packages',
					component: () => import('@/views/packages.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/profile',
					name: 'Profile',
					component: () => import('@/views/Profile.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/dashboard-management',
					name: 'Dashboard-management',
					component: () => import('@/views/DashboardManagement.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: '/support',
					name: 'Ondersteuning',
					component: () => import('@/views/Support.vue'),
					meta: {
						middleware: auth
					}
				},
			],
			meta: {
				middleware: auth
			},
		},
		{
			path: '/instellingen',
			name: 'settings',
			component: () => import('@/layouts/main/Main.vue'),
			children: [
				{
					path: 'notificaties',
					name: 'settingsNotifications',
					component: () => import('@/views/settings/notifications.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: 'verzending',
					name: 'settingsShipment',
					component: () => import('@/views/settings/shipment.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: 'levertijd',
					name: 'settingsDeliveryTime',
					component: () => import('@/views/settings/deliverytime.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: 'abonnement',
					name: 'settingsSubscription',
					component: () => import('@/views/settings/subscription.vue'),
					meta: {
						middleware: auth
					}
				},
			],
			meta: {
				middleware: auth
			}
		},
		{
			path: '/modules',
			component: () => import('@/layouts/main/Main.vue'),
			children: [
				{
					path: 'overzicht',
					name: 'modules',
					component: () => import('@/views/modules/overview.vue'),
					meta: {
						middleware: auth
					}
				},
				// === modules accounting
				{
					path: 'boekhouding/facturen',
					name: 'moduleAccountingInvoices',
					component: () => import('@/views/modules/accounting/invoices.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: 'boekhouding/eboekhouden',
					name: 'moduleAccountingEboekhouden',
					component: () => import('@/views/modules/accounting/eboekhouden.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: 'boekhouding/moneybird',
					name: 'moduleAccountingMoneybird',
					component: () => import('@/views/modules/accounting/moneybird.vue'),
					meta: {
						middleware: auth
					}
				},
				// === modules shipment
				{
					path: 'verzending/sendcloud',
					name: 'moduleShipmentSendcloud',
					component: () => import('@/views/modules/shipment/sendcloud.vue'),
					meta: {
						middleware: auth
					}
				},
				// === modules webshop
				{
					path: 'webshop/bol',
					name: 'moduleWebshopBol',
					component: () => import('@/views/modules/webshop/bol.vue'),
					meta: {
						middleware: auth
					}
				},
				{
					path: 'webshop/lightspeed',
					name: 'moduleWebshopLightspeed',
					component: () => import('@/views/modules/webshop/lightspeed.vue'),
					meta: {
						middleware: auth
					}
				},

				// === modules printing
				{
					path: 'printing/dymo',
					name: 'modulePrintingDymo',
					component: () => import('@/views/modules/printing/dymo.vue'),
					meta: {
						middleware: auth
					}
				},

				// === modules promotion
				{
					path: 'discount/promotion',
					name: 'modulePromotion',
					component: () => import('@/views/modules/discount/promotion.vue'),
					meta: {
						middleware: auth
					}
				},

				// === modules inventory
				{
					path: 'voorraad/voorraadpools',
					name: 'moduleInventoryPools',
					component: () => import('@/views/modules/inventory/pools.vue'),
					meta: {
						middleware: auth
					}
				},
			],
			meta: {
				middleware: auth
			}
		},
		{
			path: '/settings',
			name: 'oldSettings',
			component: () => import('@/layouts/main/Main.vue'),
			children: [
				// === redirecting old routes
				{
					path: 'notifications',
					redirect: '/instellingen/notificaties'
				},
				{
					path: 'deliverytime',
					redirect: '/instellingen/levertijd'
				},
				{
					path: 'sendoptions',
					redirect: '/instellingen/verzending'
				},
				{
					path: 'subscriptions',
					redirect: '/instellingen/abonnement'
				},
				{
					path: 'retailer',
					redirect: '/modules/webshop/bol'
				},
				{
					path: 'eboekhouden',
					redirect: '/modules/boekhouding/eboekhouden'
				},
				{
					path: 'moneybird',
					redirect: '/modules/boekhouding/moneybird'
				},
				{
					path: 'sendcloud',
					redirect: '/modules/verzending/sendcloud'
				},
				{
					path: 'dymo',
					redirect: '/modules/printing/dymo'
				},
			],
			meta: {
				middleware: auth
			}
		},

		// Redirect to 404 page, if no match found
		{
			path: '*',
			redirect: '/niet-gevonden'
		}
	]
});


router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById('loading-bg');
	if (appLoading) {
		appLoading.style.display = 'none'
	}
});

function nextFactory(context, middleware, index) {
	const subsequentMiddleware = middleware[index];
	// If no subsequent Middleware exists,
	// the default `next()` callback is returned.
	if (!subsequentMiddleware) return context.next;

	return (...parameters) => {
		// Run the default Vue Router `next()` callback first.
		context.next(...parameters);
		// Then run the subsequent Middleware with a new
		// `nextMiddleware()` callback.
		const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({...context, next: nextMiddleware});
	};
}

router.beforeEach((to, from, next) => {
	if (to.meta.middleware) {
		const middleware = Array.isArray(to.meta.middleware)
			? to.meta.middleware
			: [to.meta.middleware];

		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		return middleware[0]({...context, next: nextMiddleware});
	}

	return next();
});

export default router
